module.exports = __webpack_public_path__ + "img/druemmer.742c1864.png";